import React from "react";

import "./editPieceScoreElement.css";
import PDFIcon from "../../../../../assets/icons/pdfIcon";
import TextField from "../../../../../components/textField/textField";
import StraightArrowIcon from "../../../../../assets/icons/straightArrowIcon";
import DeleteButton from "../../../../../components/deleteButton";

interface EditPieceScoreElementProps {
    canMoveUp: boolean;
    canMoveDown: boolean;
    moveUp: () => void;
    moveDown: () => void;
    delete: () => void;
    defaultName: string;
    name: string;
    setName: (v: string) => void;
    deleteDisabled?: boolean;

}

export default function EditPieceScoreElement(props: EditPieceScoreElementProps) {
    return <div className="score-element">
        <PDFIcon/>
        <TextField hideMaxLength={true} maxLength={50} label={props.defaultName} value={props.name} onChange={props.setName}/>
        <div className="arrows">
            <div className={"up" + (!props.canMoveUp ? " disabled" : "")} onClick={props.moveUp}><StraightArrowIcon rotate={-90}/></div>
            <div className={"down" + (!props.canMoveDown ? " disabled" : "")} onClick={props.moveDown}><StraightArrowIcon rotate={90}/></div>
        </div>
        <DeleteButton onDelete={() => {
            if(!props.deleteDisabled) {
                props.delete();
            }
        }} disabled={props.deleteDisabled}/>
    </div>
}